import PropTypes from 'prop-types';
import React from 'react';
import style from '../openFormButton/OpenFormButton.module.css';

export const OpenWrapFormButton = ({ size, color, clickHandler, title }) => {
  return (
    <div className={style.div} onClick={clickHandler} title={title}>
      <svg
        className={style.svg}
        width={size}
        height={size}
        viewBox="0 0 36 36"
        version="1.1"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fill={color}
          d="M8 4h14a2 2 0 0 1 2 2v6l-2.8 2.8V7H8v22h8.6l-.7 3H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
        />
        <path
          fill={color}
          d="M28.9 13.2a1.8 1.8 0 0 1 2.5 0l1.4 1.4a1.8 1.8 0 0 1 0 2.5L21.2 28.7l-4.7 1 1-4.7 11.4-11.8Z"
        />
        <path fill={color} d="M11 11h9v2h-9z" />
        <path fill={color} d="M11 16h7v2h-7z" />
      </svg>
    </div>
  );
};

OpenWrapFormButton.propTypes = {
  clickHandler: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
};
